import axios from 'axios';

class Manager {
  constructor() {
    this.baseUrl = process.env.APP_URL + '/interactive-modules/dro';
    this.envUrl = process.env.APP_URL;
  }

  hasAccess(assigneeId) {
    return axios.get(this.baseUrl + '/has-access', {
      params: {assigneeId},
    });
  }

  getSettings(assigneeId) {
    return axios.get(this.baseUrl + '/settings', {
      params: {id: assigneeId},
    });
  }

  getReports(assigneeId, perPage, page) {
    return axios.get(this.baseUrl + '/sessions/', {
      params: {assigneeId, perPage, page},
    });
  }

  getDashboardProtocol(id) {
    return axios.get(this.envUrl + '/protocols/assigned/mand/' + id + '/shortcuts');
  }

  exportReports(id) {
    return axios.post(this.baseUrl + '/sessions/export', {
      id: id,
      },{responseType: 'blob'});
  }

  save(data) {
    return axios.post(this.baseUrl + '/sessions', data);
  }
}

export default new Manager();


// WEBPACK FOOTER //
// ./src/modules/dro/api/Manager.js